module.exports = __webpack_public_path__ + "img/aig_new_two.99adb5b4.png";